import { render, staticRenderFns } from "./leavesComponent.vue?vue&type=template&id=5965a68b&"
import script from "./leavesComponent.vue?vue&type=script&lang=js&"
export * from "./leavesComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports